import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import ProjectCard from "../ProjectCard";
import Button from "../Button";
import projects from "../../_data/projects.json";
import { useCopy } from "../../i18n/useCopy";

/**
 * Highlights the featured case studies on the home page.
 *
 * @component
 */

const FeaturedProjects = () => {
  const t = useCopy();
  return (
  <section className="homeSection container" aria-labelledby="featured-title">
    <SectionHeading eyebrow={t.sections.featured.eyebrow} title={t.sections.featured.title} id="featured-title">
      {t.sections.featured.lead}
    </SectionHeading>
    <div className="row">
      {projects
        .filter((project) => project.featured)
        .map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
    </div>
    <Reveal className="sectionCta">
      <Button name={t.sections.featured.button} to="/portfolio" />
    </Reveal>
  </section>
  );
};

export default FeaturedProjects;
